
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class BgVideo extends Vue {
  @Prop() private videUrl!: string;
}
